import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, GraduationCap, Radio, Users } from 'lucide-react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import './About.css';

const WORLDS = [
  { id: 'academy', accent: 'amber', icon: GraduationCap, title: 'QoreAcademy', to: '/academy', img: '/images/about/academy.jpg' },
  { id: 'talks', accent: 'rose', icon: Radio, title: 'QoreTalks', to: '/qoretalks', img: '/images/about/talks.jpg' },
  { id: 'connect', accent: 'cyan', icon: Users, title: 'QoreConnect', to: '/qoreconnect', img: '/images/about/connect.jpg' },
];

const About = () => {
  useEffect(() => {
    document.documentElement.classList.add('qn-home-html');
    document.body.classList.add('qn-home-body');
    return () => {
      document.documentElement.classList.remove('qn-home-html');
      document.body.classList.remove('qn-home-body');
    };
  }, []);

  return (
    <div className="ab">
      <Header />

      <section className="ab-hero">
        <img className="ab-hero__img" src="/images/about/hero.jpg" alt="" />
        <div className="ab-hero__veil" />
        <div className="ab-hero__copy">
          <p>QoreNova</p>
          <h1>Learn. Broadcast. Belong.</h1>
          <Link to="/academy" className="ab-btn">
            Enter Academy <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <section className="ab-worlds">
        {WORLDS.map((w) => {
          const Icon = w.icon;
          return (
            <Link key={w.id} to={w.to} className={`ab-card ab-card--${w.accent}`}>
              <img src={w.img} alt="" />
              <span>
                <Icon size={16} /> {w.title}
              </span>
            </Link>
          );
        })}
      </section>

      <section className="ab-note">
        <p>Built by Moise Ugwiri — for engineers who want the real skill, not just the degree.</p>
        <Link to="/login" className="ab-link">Start free <ArrowRight size={14} /></Link>
      </section>

      <Footer />
    </div>
  );
};

export default About;
